import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import DashboardSummary from '../../components/inventory/Dashboard/DashboardSummary.js';
import DashboardDetail from '../../components/inventory/Dashboard/DashboardDetail.js';


export default function InventoryDashboardPage( props ){
    //console.debug("RTS Break InventoryDashboardPage");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [tabIndex, setTabIndex] = useState(0);
    const [newTabIndex, setNewTabIndex] = useState(0);


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '80vh';
        }
        return retValue;
    }; 


    const handleChange = (e, curIndex) => {
        setNewTabIndex(curIndex);
        switchTabs(curIndex);
    };


    function switchTabs(curIndex){
        window.scrollTo(0,0);
        setTabIndex(curIndex);
    }  
    
    
        useEffect(() => {
            props.setIsModalFx(false);
        }, [props]); 
    


    return(
        <>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb:1 }}>
            <Tabs value={tabIndex} onChange={handleChange}>
                <Tab label="Summary" value={0}  />
                <Tab label="Details" value={1} />
            </Tabs>
        </Box>        
        <Box>
        </Box>

            {
            tabIndex === 1
            ?
                <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                    <DashboardDetail />
                </Box>
            :
                <>
                {/* <AssetsFilter filter={filter} setFilterFx={setFilter}/> */}
                <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                    <DashboardSummary />
                </Box>
                </>
            }        
        </>
    );
}
